import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconLinkedin = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M25.9942 25.9996V25.9987H25.9997V17.9301C25.9997 13.983 25.1499 10.9424 20.5354 10.9424C18.3171 10.9424 16.8284 12.1597 16.2207 13.3138H16.1565V11.3109H11.7812V25.9987H16.3371V18.7258C16.3371 16.8109 16.7001 14.9592 19.0715 14.9592C21.4081 14.9592 21.4429 17.1446 21.4429 18.8486V25.9996H25.9942Z"
            fill="#0077B5"
          />
          <path
            d="M4.36719 11.3125H8.92852V26.0002H4.36719V11.3125Z"
            fill="#0077B5"
          />
          <path
            d="M6.64183 4C5.18342 4 4 5.18342 4 6.64183C4 8.10025 5.18342 9.30842 6.64183 9.30842C8.10025 9.30842 9.28367 8.10025 9.28367 6.64183C9.28275 5.18342 8.09933 4 6.64183 4V4Z"
            fill="#0077B5"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="22"
              height="22"
              fill="white"
              transform="translate(4 4)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
